// extracted by mini-css-extract-plugin
export var chip = "_6b-9";
export var chipLabel = "_6b-a";
export var close = "_6b-7";
export var closeIcon = "_6b-8";
export var error = "_6b-6";
export var infoTooltip = "_6b-2";
export var innerContainer = "_6b-1";
export var input = "_6b-b";
export var medium = "_6b-5";
export var outerContainer = "_6b-0";
export var small = "_6b-4";
export var xSmall = "_6b-3";